/* eslint-disable */
YP.OrderManager = function() {
    var selectAction = $('.table-quickactions');
    var selectAction2 = $('.js-table-order-action .js-tooltip-item');
    var btnFilter = $('.onlysearch');
    var btnCheck = $('.onlyvalidation');
    var inputSearchTicket = $('.input_search_ticket');
    var errorLabel = $('.error', '.search_ticket');
    var isFinished = true;
    var searching = null;
    var onlySearch = false;
    var showMoreFilters = $('.js-orders_show-more-filters');
    var showFilters = $('.js-orders__show-filters');

    return {
        init: function() {
            selectAction.die('change').live('change', this.executeAction);
            selectAction2.live('click', this.executeAction2);
            btnFilter.live('click', this.displayFilter);
            btnCheck.live('click', this.displayCheck);
            inputSearchTicket.live('keypress', this.searchTicket);
            inputSearchTicket.click(function(e) {
                inputSearchTicket.select();
            });
            $('a.export-yurplanentry').live('click', this.displayTuto);
            if ($('form.addsell').length > 0) {
                YP.OrderManager().initAddOrderForm();
            }

            showMoreFilters.on('click', function(e){
                var showFilterIcon = $(this).find('i');
                e.preventDefault();
                showFilters.toggle();
                showFilterIcon.toggleClass("fa-chevron-up fa-chevron-down");
                if (showFilterIcon.hasClass("fa-chevron-up")){
                    $('.js-orders_change-word:contains("plus")').text("moins");
                } else {
                    $('.js-orders_change-word:contains("moins")').text("plus");
                }
            });
        },
        executeCheck: function(e) {
            e.preventDefault();

            var el = $(this),
                href = el.data('href'),
                rel = el.data('rel'),
                parent = el.parent().parent();
            el.parent().html('<img class="loader" src="/images/dots.gif">');
            if (rel) {
                if (rel == 'ajax') {
                    var notification = {};
                    $.post(href, function(data) {
                        if (data) {
                            parent.replaceWith(data);
                        }
                        notification.class = "success";
                    });
                }
            }
        },
        executeAction: function(e) {

            var el = $(this),
                option = el.find(":selected"),
                href = option.data('href'),
                rel = option.data('rel'),
                type = option.data('type'),
                klass = option.attr('class'),
                parent = el.parent().parent();
            if (rel) {
                if (rel == 'ajax') {
                    var notification = {};
                    $.post(href, function(data) {
                        if (data) {
                            parent.replaceWith(data);
                            $('option:first', el).attr("selected", "selected");
                            if (klass == 'entry-check') {
                                notification.message = "Le participant a bien été marqué comme entré";
                            }
                            if (klass == 'entry-uncheck') {
                                notification.message = "Le participant a bien été marqué comme non-entré";
                            }
                            if (klass == 'entry-cancel') {
                                parent.addClass('error');
                                notification.message = "Le billet a bien été annulé";
                            }
                            if (klass == 'entry-enable') {
                                parent.removeClass('error');
                                notification.message = "Le billet a bien été réactivé";
                            }
                        }
                        notification.class = "success";
                        YP.NotifManager().show(notification);
                    });
                }
                if (rel == 'ajax-notice') {
                    $.post(href, function(data) {
                        notification = {};
                        notification.message = option.data('message');
                        notification.class = "success";
                        YP.NotifManager().show(notification);
                        $('option:first', el).attr("selected", "selected");

                        _data = JSON.parse(data);
                        if (_data.view && _data.reload) { //Here for reload cashless list FIX because executeAction of order.js is binded before the one of modal.js
                            $('.ajax-container').html(_data.view);
                        }

                    });
                }
                if (rel == 'modal') {

                    if (type == "add_workshops") {
                        YP.ModalManager().setPostCallModalFailure(function() {
                            $('.addorder-workshop.select2').select2();
                        });
                        YP.ModalManager().setPostCallModalSuccess(function() {
                            $('.addorder-workshop.select2').select2();
                        });
                    }
                    YP.ModalManager().loadModal(href);

                    if (option.data('modal')) {
                        $("#main-modal").addClass(option.data('modal'));
                    } else {
                        $("#main-modal").attr('class', 'modal hide in');
                    }

                    $('option:first', el).attr("selected", "selected");
                }
                if (rel == 'blank') {
                    $('option:first', el).attr("selected", "selected");
                    window.open(href, '_blank');
                }
            } else {
                window.location.href = href;
                $('option:first', el).attr("selected", "selected");
            }
        },
        executeAction2: function(e) {
            var el = $(this),
                href = el.attr('href'),
                rel = el.data('rel'),
                klass = el.attr('class');
            if (rel == 'modal') {
                YP.ModalManager().setPreCallSuccess(function() {
                    $('.addorder-workshop.select2').select2();

                    if ($('.check_address').is(':checked')) {
                        $('#address_form').show();
                    }
                    else {
                        $('#address_form').hide();
                    }

                    $('.check_address').on('change', function() {
                        if ($(this).is(':checked')) {
                            $('#address_form').show();
                        }
                        else {
                            $('#address_form').hide();
                        }
                    });
                });
            }
        },
        displayFilter: function() {
            $('.check_ticket').hide();
            $('.div_yurplanentry.exportye').hide();
            $('.search_ticket').toggle();
        },
        displayCheck: function() {
            $(this).toggleClass("active");
            if ($(this).hasClass("active")) {
                $('.search_ticket').hide();
                $('.div_yurplanentry.exportye').hide();
            } else {
                $('.search_ticket').show();
            }
            $('.check_ticket').toggle();
        },
        displayTuto: function(e) {
            e.preventDefault();
            $('.search_ticket').hide();
            $('.check_ticket').hide();
            $('.div_yurplanentry.exportye').show();
            $('.div_yurplanentry .close').click(function() {
                $(this).parent('.div_yurplanentry').hide();
            });
        },
        searchTicket: function(e) {
            if (!isFinished) {
                e.preventDefault();
            }
            if (e.keyCode == 13) {
                isFinished = false;
                inputSearchTicket.css({
                    borderColor: '',
                    backgroundColor: ''
                });
                errorLabel.hide();
                el = $(this);
                el.addClass('waiting');
                clearTimeout(searching);
                searching = setTimeout(function() {
                    $.get(el.data('url'), {
                        'query': el.val()
                    }, function(data) {
                        count = $('#ticketing_table').html(data).find('tbody tr').length;
                        if (count == 1 && onlySearch === false) {
                            $.post(el.data('check-url'), {
                                'ticketToken': el.val()
                            }, function(data) {
                                data = JSON.parse(data);
                                if (data.error === true) {
                                    inputSearchTicket.css({
                                        borderColor: '#B94A48',
                                        backgroundColor: '#FFD1D1'
                                    });
                                    errorLabel.html('Billet déjà validé').show();
                                } else {
                                    $('.ticketing-prt-body td:first').prepend('<a rel="tipsy" title="Entré"><i class="fa fa-check-square-o"></i></a>');
                                    $('.ticketing-prt-body tr:first').css('background-color', '#dff0d8');
                                }
                                el.removeClass('waiting');
                                isFinished = true;
                            });
                        } else {
                            el.removeClass('waiting');
                            isFinished = true;
                        }
                    });
                }, 1000);
                inputSearchTicket.select();
                e.preventDefault();
            }
        },
        initAddOrderForm: function() {
            var addSellZone = $('.add-sell.form_tab');
            document.getElementById('js-confirm-addsell').setAttribute('disabled', '');
            $(document).on('click', '#js-confirm-addsell', function(e) {
                $('#js-form-addsell').hide();
                $('.event-orders-add-container_searching').show();
                addSellZone.html('');
                e.preventDefault();
                $('em.required').remove();
                var $form = $('form.addsell');
                $.ajax({
                    url: $form.attr('ajax-action'),
                    type: $form.attr('method'),
                    data: $form.serialize(),
                    success: function(html) {
                        $('.event-orders-add-container_searching').hide();
                        if (html) {
                            // addSellZone.append('<h3>Informations billets</h3>');
                            addSellZone.append(html);
                            const ticketingSessionId = addSellZone.find('#js-form-addsell').attr('data-ticketing-session-id');
                            $form.attr('action', $form.attr('action').split('?')[0] + `?ypTicketingSession=${ticketingSessionId}`)
                            $('#js-form-addsell').show();
                            $('.js-orders__show-add-btn').show();

                            $('.js-geocoder-input').each(function() {
                                $(this).removeClass('js-geocoder-input').addClass('js-async-geocoder-input');
                            })

                            if ($('.js-async-geocoder-input').length > 0) {
                                const checkGeocoder = setInterval(() => {
                                    if (typeof window.initializeGeocoder === 'function') {                                    
                                        clearInterval(checkGeocoder);
                                        window.initializeGeocoder();
                                    } else {
                                        console.error('initializeGeocoder is not defined');
                                    }
                                }, 100);
                            }
                        } else {
                            addSellZone.html('');
                        }

                        initDatePicker()
                        YP.OrderManager().updatePaymentMode();
                        $(".addsell").validate({
                            highlight: function(element, errorClass, validClass) {
                                $(element).parents('.field-box').addClass('error');
                            },
                            unhighlight: function(element, errorClass, validClass) {
                                $(element).parents('.field-box').removeClass('error');
                            },
                            errorPlacement: function(error, element) {
                                if (!$(element).parents('.field-box').find('label.error').length) {
                                    $(element).parents('.field-box').append("<label class='error'>" + error.text() + "</label>");
                                }
                            }
                        });

                        function format(state) {
                            if (!state.id) return state.text; // optgroup
                            left = $(state.element[0]).attr('left');
                            if (left === undefined) return state.text;
                            return state.text + ' <span class="quantity" data-id="' + state.id + '"><span class="value">' + left + '</span> restant</span>';
                        }
                        $('.select2').select2({
                            allowClear: true,
                            formatResult: format,
                            escapeMarkup: function(m) {
                                return m;
                            }
                        }).on("select2-selecting", function(e) {
                            element = $(e.object.element[0]);
                            elementId = e.val;
                            left = element.attr('left');
                            if (left !== undefined) {
                                currentLeft = Math.abs(left) - 1;
                                $('.addorder-workshop option[value=' + elementId + ']').attr('left', currentLeft);
                                $('.addorder-workshop option[value=' + elementId + '][left=0]').not(element).attr('disabled', 'disabled');
                                $('.select2 .quantity[data-id=' + elementId + '] .value').text(currentLeft);
                            }
                        }).on("select2-removed", function(e) {
                            element = $(e.choice.element[0]);
                            elementId = e.val;
                            left = element.attr('left');
                            if (left !== undefined) {
                                currentLeft = Math.abs(left) + 1;
                                $('.addorder-workshop option[value=' + elementId + ']').attr('left', currentLeft);
                                $('.addorder-workshop option[value=' + elementId + '][left!=0]').removeAttr('disabled');
                                $('.select2 .quantity[data-id=' + elementId + '] .value').text(currentLeft);
                            }
                        });

                        YP.TypeProduct().init();

                        $('.loader').remove();
                    }
                });
            });

            $('table.js-total-ticket tbody select.nbSeat').change(function() {
                var $table = $('table.js-total-ticket');
                var $total = $(this).parents('tr').find('.total .change_price');
                var $grandTotal = $table.find('tfoot .grandtotal span');

                var nbTicket = $(this).val();
                var price = parseFloat($(this).parents('tr').find('.price span.val span').text().replace(/\,/g, '')) || 0;
                var total = nbTicket * price;
                var grandTotal = 0;
                var selectedTickets = false;

                $total.text(total.toFixed(2));
                $table.find('tbody .total .change_price').each(function() {
                    pp = parseFloat($(this).text());
                    if (!isNaN(pp)) {
                        grandTotal = grandTotal + parseFloat($(this).text());
                    }
                });
                $table.find('tbody select.nbSeat').each(function() {
                    if (parseInt($(this).val()) > 0) {
                        selectedTickets = true;
                    }
                });
                if (selectedTickets) {
                    document.getElementById('js-confirm-addsell').removeAttribute('disabled');
                } else {
                    document.getElementById('js-confirm-addsell').setAttribute('disabled', '');
                }
                $grandTotal.text(grandTotal.toFixed(2));
            });

            $('.check_send_order, .check_send_bill').on('change', function(e) {
                if (e.target.checked) {
                    $('.js-select-language').show();
                } else {
                    $('.js-select-language').hide();
                }
            });

            $('form.addsell').on('change', '.payment_mode input[type=radio]', function() {
                if (this.value == 0) {
                    $('.payment_informations').show();
                    $('.delayed_payment_mode_info').hide();
                    $('form.addsell .check_send_bill').show();
                    $('form.addsell .check_send_order').show();
                }
                else {
                    $('.payment_informations').hide();
                    $('.delayed_payment_mode_info').show();

                    $('form.addsell .check_send_bill input[type=checkbox]').prop('checked', false);
                    $('form.addsell .check_send_bill').hide();
                    $('form.addsell .check_send_order input[type=checkbox]').prop('checked', false);
                    $('form.addsell .check_send_order').hide();

                    $('.js-select-language').show();
                }
            });

            $('form.addsell').on('change', '.check_address input[type=checkbox]', function() {
                if ($(this).is(':checked')) {
                    $('#address_form').show();
                }
                else {
                    $('#address_form').hide();
                }
            });

        },
        updatePaymentMode: function(grandTotal) {
            grandTotal = parseFloat($('table.js-total-ticket tfoot .grandtotal span').text());
            $('.delayed_payment_advert_container').removeClass('hide');

            if ($('form.addsell .payment_mode #addsell_payment_mode_1').length) {
                if (grandTotal == 0) {
                    $('form.addsell .payment_mode #addsell_payment_mode_0').prop('checked', true);
                    $('form.addsell .payment_mode #addsell_payment_mode_1').hide();
                    $('form.addsell .payment_mode label[for="addsell_payment_mode_1"]').hide();
                }
                else {
                    $('form.addsell .payment_mode #addsell_payment_mode_1').show();
                    $('form.addsell .payment_mode label[for="addsell_payment_mode_1"]').show();
                    $('form.addsell .payment_mode label[for="addsell_payment_mode_1"]').show();
                }
            }
        }
    };
};

function calcRefundAmount() {
    var tickets = [];
    var currentSelected = $('.js-cancel-order .js-table-input:not(.js-locked):checked');
    var sum = 0;

    // Update the sum depending on the type tickets and their values, only if at least one type ticket is checked
    if (currentSelected.length >= 1) {
        currentSelected.each(function() {
            var pack = $(this).data("pack");
                price = parseFloat($(this).data('price').replace(',', '.'));

            if (tickets.hasOwnProperty(pack) === false) {
                tickets[pack] = price;
            }
            sum += price;
        });

        $('.js-cancelsell-refund-amount:not([disabled])').val(sum);
    // Otherwise, no sum shall be indicated, preventing the user to validate an incomplete form
    } else {
        $('.js-cancelsell-refund-amount:not([disabled])').val(null);
    }
}

window.addEventListener("load", function() {
    if ($('#orders, .js-order').length > 0) {
        YP.OrderManager().init();
    }
});
